/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApplicationDto } from './application-dto';
import { HomeyStatus } from './homey-status';
import { InAppNotificationDto } from './in-app-notification-dto';
import { ConnectedAccountDto } from './connected-account-dto';
import { UserDtoNycProfile } from './user-dto-nyc-profile';
import { NotificationChannelsDto } from './notification-channels-dto';
import { HomeyDomainEventAuditLogDto } from './homey-domain-event-audit-log-dto';
import { IgnoredReason } from './ignored-reason';
import { NotificationCategoryPreferencesDto } from './notification-category-preferences-dto';
import { UserSyncProcessingStateDto } from './user-sync-processing-state-dto';
import { HousingConnectProfileDto } from './housing-connect-profile-dto';
import { UserDtoHouseholdInfo } from './user-dto-household-info';
import { UserDtoNotificationsInner } from './user-dto-notifications-inner';
import { EmailDto } from './email-dto';
import { UserDtoSubscription } from './user-dto-subscription';


export interface ActiveUserDetailDto { 
    type: ActiveUserDetailDto.TypeEnum;
    id: string;
    anonymousId: string;
    status: HomeyStatus;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    smsNotificationsEnabled: boolean;
    createdAt: string;
    lastSeen: string;
    source: string;
    birthDate?: string;
    trialing: boolean;
    rentalAssistance: boolean;
    subscription?: UserDtoSubscription;
    nycProfile?: UserDtoNycProfile;
    mails: Array<EmailDto>;
    notifications: Array<UserDtoNotificationsInner>;
    inAppNotifications: Array<InAppNotificationDto>;
    notificationChannels: NotificationChannelsDto;
    notificationCategoryPreferences?: NotificationCategoryPreferencesDto;
    householdInfo?: UserDtoHouseholdInfo;
    applications: Array<ApplicationDto>;
    domainEvents: Array<HomeyDomainEventAuditLogDto>;
    syncProcessingState?: UserSyncProcessingStateDto;
    ignore: boolean;
    ignoredReason: IgnoredReason;
    connectedAccounts: Array<ConnectedAccountDto>;
    housingConnectProfile?: HousingConnectProfileDto;
}
export namespace ActiveUserDetailDto {
    export const TypeEnum = {
        user: 'user'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


